import { httpClient } from './http/httpClient.js';

const STORAGE_IMAGES_API_URL = '/api/storage/images';

const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') {
      return;
    }

    searchParams.append(key, String(value));
  });

  return searchParams.toString();
};

const ensureSuccessPayload = (payload, fallbackMessage) => {
  if (payload && typeof payload === 'object' && payload.success === false) {
    throw new Error(payload.message || fallbackMessage);
  }

  return payload;
};

const getStorageFilesCollection = (payload) => {
  if (Array.isArray(payload?.files)) {
    return payload.files;
  }

  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  return [];
};

export const uploadStorageImages = async ({ folderName, files = [] }) => {
  const formData = new FormData();
  formData.append('folderName', folderName);

  Array.from(files).forEach((file) => {
    formData.append('imagesList', file);
  });

  const payload = ensureSuccessPayload(
    await httpClient.post(STORAGE_IMAGES_API_URL, { body: formData }),
    'No se pudieron subir las imagenes.'
  );

  return Array.isArray(payload?.urls) ? payload.urls : [];
};

export const deleteStorageImage = async ({ fileId }) => {
  const payload = ensureSuccessPayload(
    await httpClient.delete(`${STORAGE_IMAGES_API_URL}/${fileId}`),
    'No se pudo eliminar la imagen.'
  );

  return payload;
};

export const getStorageImagesByFolder = async ({ folderName, offset = 0, pageSize = null }) => {
  const queryString = buildQueryString({ folderName, offset, pageSize });
  const url = queryString ? `${STORAGE_IMAGES_API_URL}?${queryString}` : STORAGE_IMAGES_API_URL;
  const payload = ensureSuccessPayload(
    await httpClient.get(url),
    'No se pudieron obtener las imagenes.'
  );

  return {
    success: payload?.success ?? true,
    files: getStorageFilesCollection(payload),
    totalCount: Number.isInteger(payload?.totalCount) ? payload.totalCount : null,
    payload
  };
};

export const storageImageService = {
  uploadStorageImages,
  getStorageImagesByFolder,
  deleteStorageImage
};
